import { apiClient } from '@/api'

let calendarRequest = 0

const requireList = (res) => {
  if (res?.success === false || !Array.isArray(res?.list)) throw new Error(res?.error?.message || 'Ошибка загрузки смен');
  return res.list;
}

export default {
  namespaced: true,
  state: () => ({
    schedules: [],
    currentDate: new Date(),
    editingSchedule: null,
    schedulesTemplates:[]
  }),
  mutations: {
    SET_TEMPLATES(state, items) {
      state.schedulesTemplates = items
    },
    SET_SCHEDULES(state, items) {
      state.schedules = items
    }
  },
  actions: {
    async getCurrentSchedules({ commit }, data) {
      const res = await apiClient('schedules.current', data)
      commit('SET_SCHEDULES', requireList(res))
    },
    async fetchSchedules({ commit }, param) {
      const res = await apiClient('schedules.get', param)
      commit('SET_SCHEDULES', requireList(res))
    },
    async fetchCalendarSchedules({ commit }, param) {
      const request = ++calendarRequest
      const res = await apiClient('calendar.schedules', param)
      const list = requireList(res)
      if (request === calendarRequest) commit('SET_SCHEDULES', list)
    },
    async saveSchedule({ commit }, scheduleData) {
      const res = await apiClient('schedules.create', scheduleData)
      commit('SET_SCHEDULES', requireList(res))
    },
    async updateSchedule({ commit }, scheduleData) {
      const res = await apiClient('schedules.update', scheduleData)
      commit('SET_SCHEDULES', requireList(res))
    },
    async deleteSchedule({ commit }, data) {
      const res = await apiClient('schedules.delete', data)
      commit('SET_SCHEDULES', requireList(res))
    },
    async fetchScheduleTemplates({ commit }) {
      const res = await apiClient('schedule_templates.get')
      commit('SET_TEMPLATES', res.list)
    },
    async deleteScheduleTemplates({ commit }, id) {
      const res = await apiClient('schedule_templates.delete', { id })
      commit('SET_TEMPLATES', res.list)
    },
    async saveScheduleTemplate({ commit }, scheduleData) {
      // Если есть id - обновление, иначе создание
      const method = scheduleData.id ? 'schedule_templates.update' : 'schedule_templates.create'
      const res = await apiClient(method, scheduleData)
      // Обновляем список шаблонов после операции
      commit('SET_TEMPLATES', res.list)
    },
  },
  getters: {
    getByRoomAndDate: state => (room_id, date) => {
      const d = typeof date === 'string'
        ? date
        : date.toISOString().split('T')[0]
      return state.schedules.filter(s => s.room_id === room_id && s.date === d)
    }
  }
}
